export const buttons = [
  {
    name: 'Beginner',
  },
  {
    name: 'Intermediate',
  },
  {
    name: 'Expert',
  },
];
export const types = [
  { name: 'Yes', value: 1 },
  { name: 'No', value: 0 },
];
export const assignOption = [
  {
    value: 'department',
    name: 'Department',
  },
  {
    value: 'rule',
    name: 'Rule',
  },
];
